import { render, staticRenderFns } from "./UserProfileCertificatesIndex.vue?vue&type=template&id=292c2701"
import script from "./UserProfileCertificatesIndex.vue?vue&type=script&lang=js"
export * from "./UserProfileCertificatesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports